import React from 'react'
import styled from 'styled-components';

const Div = styled.div`
.container{
    width: 400px;
    min-height: 50px;
    position: fixed;
    top: 20px;
    right: 20px;
    display: none;
    grid-template-columns: 0fr 1fr 0fr; 
    color: white;
    border-radius: 5px;
    box-shadow: 1px 1px 10px 1px lightgrey;
    z-index: 99999;
    :hover {
        filter: contrast(90%);
    }
    .icon{
        background-repeat: no-repeat;
        background-position: 10px 12px;
        width: 40px;
        height: 100%;
        border-radius: 5px 0px 0px 5px;
    }
    .content {
        padding: 10px;
        width: 330px;
        overflow-x: hidden;
        overflow-wrap: break-word;
        .head {
            font-weight: bolder;
        }
        .body {
            padding-top: 5px;
            font-size: 14px;
        }
    }
    .close {
        border-radius: 5px;
        button {
            margin: 5px;
            background: transparent;
            border: none;
            color: white;
            :hover {
                color: black
            }
        }
    }
}
.container-success {
    background: #38a76a;
    .icon {
        background-color: #449c6b;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==')!important;
    }
}

.container-error {
    background: #b85252;
    .icon {
        background-color: indianred;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=')!important;
    }
}

.container-info {
    background: cadetblue;
    .icon {
        background-color: #508688;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=')!important;
    }
}

.container-warning {
    background: #f89406;
    .icon {
        background-color: #db8102;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=')!important;
    }
}

@keyframes slide_in {
    0% {
        right: -500px;
    }
    100% {
        right: 20px;
    }
}

@keyframes slide_out {
    0% {
        right: 20px;
    }
    100% {
        right: -500px;
    }
}
.animate-in {
    display: grid;
    -webkit-animation: slide_in 0.8s ease forwards ;
    animation: slide_in 0.8s ease forwards;
}
.animate-out {
    display: grid;
    -webkit-animation: slide_out 0.8s ease forwards;
    animation: slide_out 0.8s ease forwards;
    /* animation-delay: 10s; */
}

.hover-tab {
    position: absolute;
    display: none;
    width: 200px;
    background: #fff;
    box-shadow: 0px 1px 5px #CCCCCC80;
    z-index: +50;
    padding: 10px;
    cursor: pointer;
    margin-left: -80px;
    color: grey;

    .tab-list {
        &:hover {
            background: #f8fcfb;
            color: #007B5D;
        }
    }
}
.click-hover-tab {
    cursor: pointer;
    color: #007B5D;
    font-style: oblique;
}
.click-hover-tab:hover ~ .hover-tab{
    display: inline-block!important;
}
.hover-tab:hover {
    display: inline-block!important;
}
.deep-green{
    font: normal normal 600 15px/19px Montserrat;
    color: #007B5D;
    width: fit-content;
}

`
export default function Toast(props: any) {
    const {config} = props;
    return (
        <Div>
            <div className={`container container-${config?.type} ${config?.show ? 'animate-in': '' } ${((config?.show && config?.readyToClose) ? 'animate-out': '')}`}>
                <div className="icon">
                </div>
                <div className="content">
                    <div className="head">{config?.title || ""}</div>
                    <div className="body" dangerouslySetInnerHTML={{__html: config?.message || "Success"}} ></div>
                </div>
                <div className="close">
                    <button>x</button>
                </div>
            </div>
        </Div>
    )
}
